/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Note_PlaceholderInputs */

const en_history_note_placeholder = /** @type {(inputs: History_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`more chilli, 10 min longer in the oven`)
};

const de_history_note_placeholder = /** @type {(inputs: History_Note_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mehr Chili, 10 Min. länger im Ofen`)
};

/**
* | output |
* | --- |
* | "more chilli, 10 min longer in the oven" |
*
* @param {History_Note_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const history_note_placeholder = /** @type {((inputs?: History_Note_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Note_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_history_note_placeholder(inputs)
	return en_history_note_placeholder(inputs)
});